
    const _getMitoDs = (ds) => ds || (typeof globalThis !== 'undefined' && globalThis._currentMitologiData) || null;
    export const getAllMitologiNusantara = (ds) => {
      const d = _getMitoDs(ds);
      if (!d) return [];
      if (Array.isArray(d)) return d;
      if (Array.isArray(d.mitologi_list)) return d.mitologi_list;
      return [];
    };
    export const getMitologiById = (id, ds) => {
      if (!id) return null;
      const list = getAllMitologiNusantara(ds);
      return list.find(m => m && m.id === id) || null;
    };
    export const formatMitologiPlainText = (item) => {
      if (!item) return '';
      let out = '📜 ' + (item.judul || '') + '\n';
      out += (item.judulJawa || '') + ' (' + (item.aksaraJawa || '') + ')\n';
      out += 'Kategori: ' + (item.kategori || '') + '\n';
      out += '====================================================\n\n';
      out += 'Ringkasan:\n' + (item.ringkasan || '') + '\n\n';
      if (Array.isArray(item.babList)) {
        item.babList.forEach(b => {
          out += '[ ' + (b.subjudul || '') + ' ]\n';
          out += (b.teks || '') + '\n\n';
        });
      }
      if (item.pesanMoral) {
        out += '💡 Falsafah & Piwulang Luhur:\n' + item.pesanMoral + '\n\n';
      }
      out += 'Kadhudhah saking Mitologi Nusantara — Jagad Jawa\nhttps://jagad-jawa.web.app';
      return out;
    };
    export const searchMitologiNusantara = (query = '', ds) => {
      const list = getAllMitologiNusantara(ds);
      const q = String(query).toLowerCase().trim();
      if (!q) return list;
      return list.filter(m =>
        (m.judul && m.judul.toLowerCase().includes(q)) ||
        (m.judulJawa && m.judulJawa.toLowerCase().includes(q)) ||
        (m.kategori && m.kategori.toLowerCase().includes(q)) ||
        (m.ringkasan && m.ringkasan.toLowerCase().includes(q))
      );
    };
    export const MITOLOGI_NUSANTARA_DB = [];
    export const KATEGORI_MITOLOGI = [];
    export const PULAU_LIST = [];
  